import { createFileRoute, redirect } from '@tanstack/react-router';
export const Route = createFileRoute('/_staff/work-schedule/_layout/')({
  beforeLoad: () => {
    throw redirect({
      to: '/work-schedule/shifts'
    });
  }
});